import { gql } from '@apollo/client';

export const ADD_USER_WALLET = gql`
  mutation AddUserWallet($address: String!, $label: String) {
    addUserWallet(address: $address, label: $label) {
      id
      userId
      address
      label
      createdAt
      updatedAt
    }
  }
`;

export const REMOVE_USER_WALLET = gql`
  mutation RemoveUserWallet($address: String!) {
    removeUserWallet(address: $address)
  }
`;


